import { LazyWithSuspense } from '../LazyWithSuspense';

// Usage with dynamic imports
const IntegrationPageLazy = LazyWithSuspense(() => import('src/views/project/IntegrationsPage')
  .then((module) => ({ default: module.IntegrationsPage })));

const InstallationsPageLazy = LazyWithSuspense(() => import('src/views/project/InstallationsPage')
  .then((module) => ({ default: module.InstallationsPage })));

const OperationsPageLazy = LazyWithSuspense(() => import('src/views/project/OperationsPage')
  .then((module) => ({ default: module.OperationsPage })));

const OperationLogsPageLazy = LazyWithSuspense(() => import('src/views/project/OperationLogsPage/OperationLogsPage')
  .then((module) => ({ default: module.OperationLogsPage })));

const BrowseOperationsPageLazy = LazyWithSuspense(() => import('src/views/project/BrowseOperationsPage/BrowseOperationsPage')
  .then((module) => ({ default: module.BrowseOperationsPage })));

const GeneralSettingsPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/GeneralSettingsPage')
  .then((module) => ({ default: module.GeneralSettingsPage })));

const ApiKeysPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/ApiKeysPage')
  .then((module) => ({ default: module.ApiKeysPage })));

const ProviderAppsPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/ProviderAppsPage')
  .then((module) => ({ default: module.ProviderAppsPage })));

const DestinationsPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/DestinationsPage')
  .then((module) => ({ default: module.DestinationsPage })));

const NotificationsPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/NotificationsPage')
  .then((module) => ({ default: module.NotificationsPage })));

const JwtKeysPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/JwtKeysPage')
  .then((module) => ({ default: module.JwtKeysPage })));

const TopicsPageLazy = LazyWithSuspense(() => import('src/views/project/Settings/TopicsPage')
  .then((module) => ({ default: module.TopicsPage })));

const AndiPageLazy = LazyWithSuspense(() => import('src/views/project/AndiPage/AndiPage')
  .then((module) => ({ default: module.AndiPage })));

export {
  AndiPageLazy,
  ApiKeysPageLazy,
  DestinationsPageLazy,
  IntegrationPageLazy,
  InstallationsPageLazy,
  BrowseOperationsPageLazy,
  GeneralSettingsPageLazy,
  NotificationsPageLazy,
  JwtKeysPageLazy,
  OperationsPageLazy,
  OperationLogsPageLazy,
  ProviderAppsPageLazy,
  TopicsPageLazy,
};
